import { render, staticRenderFns } from "./elevatorComponents.vue?vue&type=template&id=5d4dfaf4&scoped=true&"
import script from "./elevatorComponents.vue?vue&type=script&lang=js&"
export * from "./elevatorComponents.vue?vue&type=script&lang=js&"
import style0 from "./elevatorComponents.vue?vue&type=style&index=0&id=5d4dfaf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4dfaf4",
  null
  
)

export default component.exports